import React from "react";

const Description = () => (
  <>
    <section id={"description"} className={"section effect-section"}>
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-lg-6 min-h-350px"}>
            <div
              className={
                "p-100px-tb p-50px-r lg-p-0px-r d-flex align-items-center h-100"
              }
            >
              <picture>
                <source
                  type="image/webp"
                  srcSet={require("../images/banners/banner2.webp")}
                />
                <source
                  type="image/png"
                  srcSet={require("../images/banners/banner2.png")}
                />
                <img
                  data-src={require("../images/banners/banner2.png")}
                  title="Si tu empresa no está en internet, estás perdiendo clientes"
                  alt="member"
                  loading={"lazy"}
                  width={756}
                  height={638}
                  className={"max-width-140 resize-img banner2 lazyload"}
                />
              </picture>
            </div>
            <div
              className={"mask-50vw left parallax"}
              style={{
                backgroundImage: `url(${require("../images/plandev.webp")})`,
              }}
            >
              <div className={"mask opacity-8 theme-bg"} />
            </div>
          </div>
          <div className={"col-lg-6 min-h-350px"}>
            <div
              className={
                "p-100px-tb p-50px-r lg-p-0px-r d-flex align-items-center h-100"
              }
            >
              <div>
                <h1 className={"display-4 font-w-700 white-color"}>
                  {" "}
                  If your company is not on the internet, you are losing
                  customers
                </h1>
                <p className={"lead white-color"}>
                  Companies that make progress in their digital transformation
                  process have competitive advantages and are better prepared
                  for the future.
                </p>
              </div>
            </div>
            <div
              className={"mask-50vw right parallax"}
              style={{
                backgroundImage: `url(${require("../images/planpar.webp")})`,
              }}
            >
              <div className={"mask opacity-8 theme-bg"} />
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Description;
